document.querySelectorAll('.before-after-slide').forEach(slider => {
  const wrapper = slider.querySelector('.image-after-wrapper');
  const line = slider.querySelector('.slider-line');
  const handle = slider.querySelector('.slider-handle');

  let value = 50;
  let dragging = false;
  let pointerId = null;
  let rect = null;
  let raf = null;

  function render() {
    wrapper.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    line.style.left = `${value}%`;
    handle.style.left = `${value}%`;
  }

  function scheduleRender() {
    if (raf) return;

    raf = requestAnimationFrame(() => {
      raf = null;
      render();
    });
  }

  function updatePosition(clientX) {
    let x = clientX - rect.left;
    x = Math.max(0, Math.min(rect.width, x));

    value = (x / rect.width) * 100;

    scheduleRender();
  }

  function onMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    updatePosition(e.clientX);
  }

  function onUp(e) {
    if (e.pointerId !== pointerId) return;

    dragging = false;
    pointerId = null;
    rect = null;

    slider.classList.remove('dragging');

    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    window.removeEventListener('pointercancel', onUp);
  }

  slider.addEventListener('pointerdown', e => {
    e.preventDefault();

    dragging = true;
    pointerId = e.pointerId;
    rect = slider.getBoundingClientRect();

    slider.classList.add('dragging');

    updatePosition(e.clientX);

    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  });

  render();
});